module.exports = __webpack_public_path__ + "img/6-4.9e4411b3.jpg";